import Axios from "axios"
import qs from "qs"

const adios = Axios.create({ baseURL: import.meta.env.VITE_API_ENDPOINT + "/api/v1" })

adios.interceptors.request.use(function (configuration) {
    const token = localStorage.getItem("token")

    if (token) {
        const strToken = JSON.parse(token)
        configuration.headers["Authorization"] = `Token ${strToken}`
    }
    return configuration
})

adios.interceptors.response.use(
    function (response) {
        if (response.headers["content-type"] === "application/json") {
            return response.data
        }
        return response
    },
    function (error) {
        if (error.status === 401) {
            localStorage.clear()
            window.location.href = "/"
        }
        if ("response" in error) {
            return Promise.reject(error.response.data ?? error.response)
        }
        return Promise.reject(error)
    }
)

export default adios
export const paramsSerializer = {
    serialize: (params) => qs.stringify(params, { arrayFormat: "repeat" })
}
